import ReactGA from 'react-ga';
import TagManager from 'react-gtm-module';
import { useContext, useEffect, useRef } from 'react';
import LeadGenerationContext from '../context/LeadGenerationContext';

const Analytics = (props) => {
  const leadGenerationContext = useContext(LeadGenerationContext);
  const { initiateUiResponse, setGoogleCID } = leadGenerationContext;
  const gaInitializedRef = useRef(false);
  const gaReadyRef = useRef(false);

  const initGA = (id) => {
    if (!id || gaInitializedRef.current) return;

    gaInitializedRef.current = true;
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    script.onload = () => {
      window.gtag('js', new Date());
      window.gtag('config', id);
      gaReadyRef.current = true;
    };
    script.onerror = () => {
      gaInitializedRef.current = false;
      gaReadyRef.current = false;
    };
    document.head.appendChild(script);
  };

  useEffect(() => {
    if (initiateUiResponse?.REACT_APP_GA_TRACKING_ID) {
      initGA(initiateUiResponse?.REACT_APP_GA_TRACKING_ID);
    }
    if (
      initiateUiResponse?.REACT_APP_ENVIRONMENT === 'production' ||
      initiateUiResponse?.REACT_APP_ENVIRONMENT === 'development'
    ) {
      const tagManagerArgs = {
        gtmId: initiateUiResponse?.REACT_APP_GTM_ID,
      };
      TagManager.initialize(tagManagerArgs);

      const tryInitReactGA = () => {
        if (!gaReadyRef.current) {
          setTimeout(tryInitReactGA, 50);
          return;
        }
        ReactGA.initialize(initiateUiResponse?.REACT_APP_GA_TRACKING_ID);
        ReactGA.pageview(window.location.pathname + window.location.search);

        if (window.ga) {
          window.ga((tracker) => {
            const clientId = tracker.get('clientId');
            setGoogleCID(clientId);
          });
        }
      };
      tryInitReactGA();
    }
  }, [initiateUiResponse]);

  return null;
};

export default Analytics;
